import React from "react";
import ThemeTogglerTwo from "../../components/common/ThemeTogglerTwo";

export default function ImgLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <div className="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
            <div className="relative flex flex-col justify-center w-full min-h-screen lg:flex-row dark:bg-gray-900 sm:p-0">
                {children}
                <div className="items-center hidden w-full min-h-full lg:w-1/2 dark:bg-white/5 lg:grid"
                    style={{ backgroundImage: "url('/images/bg/bg-onboarding3.jpg')", backgroundSize: "cover", backgroundPosition: "center" }}>
                </div>
                <div className="fixed z-50 hidden bottom-6 right-6 sm:block">
                    <ThemeTogglerTwo />
                </div>
            </div>
        </div>
    );
}